import { render, staticRenderFns } from "./WarehouseAgingPallet.vue?vue&type=template&id=6ca9d1b8"
import script from "./WarehouseAgingPallet.vue?vue&type=script&lang=js"
export * from "./WarehouseAgingPallet.vue?vue&type=script&lang=js"
import style0 from "./WarehouseAgingPallet.vue?vue&type=style&index=0&id=6ca9d1b8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports